import React from 'react';
import styles from './Tutorial.module.scss';
import { CloseIcon } from '@src/Components/Icons';

type ITutorial = {
  type?: 'drag' | 'click';
  onClose?: () => void;
};

const Tutorial: React.FC<ITutorial> = ({ type = 'drag', onClose }) => {
  return (
    <div className={styles['container']}>
      <p className={styles['title']}>Tutorial</p>
      <p className={styles['description']}>
        {type == 'drag'
          ? 'Drag left or right to see other location.'
          : 'Click on any point, and the detail will pop up.'}
      </p>
      <div className={styles['image-wrapper']}>
        <img
          src={`assets/${
            type === 'drag' ? 'tutorial.png' : 'tutorial-point.png'
          }`}
          alt="tutorial-img"
        />
      </div>
      <div className={styles['close-icon']} onClick={onClose}>
        <CloseIcon />
      </div>
    </div>
  );
};

export default Tutorial;
